jQuery(document).ready(function () {
    $(document).on('submit','.dnRolesManageForm', function(e){
        e.preventDefault();

        var form = $(this);
        var url = form.attr('action');
        var toReplace = $(this).data('to-replace');

        var buttons = form.find('button');

        var enableLoadingButton = function() {
            buttons.each(function() {
                $(this).enableLoadingAnimation(true);
            });
        };

        var disableLoadingButton = function() {
            buttons.each(function() {
                $(this).enableLoadingAnimation(false);
            });
        };

        var resetForm = function() {
            form.trigger("reset");
            $('.dnjsChoices-hasItem').each(function () {
                $(this).removeClass('dnjsChoices-hasItem');
            });
        };

        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(),
            beforeSend: function(){
                enableLoadingButton();
            },
            success: function (response) {
                var newform = $($.parseHTML(response)).find(toReplace);

                $(toReplace).html(newform.html());
                resetForm();

                disableLoadingButton();

            },
            error: function() {
                disableLoadingButton();
            }
        });

    });
});
